import { OwnerFactory } from '@/services/ownerFactory'
import { ChocoboFactory } from '@/services/chocoboFactory'
import { AuctionManager } from '@/services/auctionManager'
import { Owner } from '@/models/owner'

export class NemesisManager {
  static createNemesisOwner(playerRegion) {
    const firstName = 'Chocobo';
    
    // Pass null for ranchName and homeRegion to trigger nemesis name generation
    const nemesis = new Owner(firstName, null, null);
    
    // Set properties after creation
    nemesis.ranchName = OwnerFactory.generateRandomRanchName();
    nemesis.homeRegion = playerRegion;
    
    // Override base stats to be highly competitive
    nemesis.shrewdness = 85 + Math.floor(Math.random() * 15);
    nemesis.ambition = 90 + Math.floor(Math.random() * 10);
    nemesis.competitiveness = 95 + Math.floor(Math.random() * 5);
    nemesis.money = 50000 + Math.floor(Math.random() * 50000);
    nemesis.isNemesis = true;
    
    return nemesis;
  }


  static processNemesisActions(gameStore, nemesis) {
    const playerBestChocobo = this.findBestChocobo(gameStore.playerChocobos)
    const nemesisBestChocobo = this.findBestChocobo(
      gameStore.chocobos.filter(c => nemesis.chocoboIds.includes(c.id))
    )

    if (!nemesisBestChocobo || 
        this.calculateChocoboScore(nemesisBestChocobo) < this.calculateChocoboScore(playerBestChocobo)) {
      this.attemptImprovement(gameStore, nemesis, playerBestChocobo)
    }
  }

  static calculateChocoboScore(chocobo) {
    return (chocobo.speed * 1.2) + chocobo.stamina + 
           (chocobo.level * 2) +
           (chocobo.hasSpeedXFactor ? 50 : 0) +
           (chocobo.hasStaminaXFactor ? 50 : 0) +
           ((8 - chocobo.behaviorId) * 10)
  }

  static findBestChocobo(chocobos) {
    return chocobos.reduce((best, current) => 
      this.calculateChocoboScore(current) > this.calculateChocoboScore(best) ? current : best
    , chocobos[0])
  }

  static attemptImprovement(gameStore, nemesis, playerChocobo) {
    // Try to buy better chocobos
    const availableChocobos = gameStore.chocobos.filter(chocobo => 
      !nemesis.chocoboIds.includes(chocobo.id) &&
      chocobo.region === nemesis.homeRegion &&
      this.calculateChocoboScore(chocobo) >= this.calculateChocoboScore(playerChocobo) * 0.9
    )

    availableChocobos.forEach(chocobo => {
      const baseValue = AuctionManager.calculateBaseValue(chocobo)
      if (nemesis.money >= baseValue * 1.5) {
        const owner = gameStore.owners.find(o => o.chocoboIds.includes(chocobo.id))
        if (owner) {
          AuctionManager.handleSale(chocobo, nemesis, owner, Math.round(baseValue * 1.5), gameStore)
        }
      }
    })

    // Generate new chocobo through expedition-like mechanics if needed
    if (nemesis.chocoboIds.length < 5) {
      const newChocobo = ChocoboFactory.generateHighLevelChocobo(
        Math.max(5, playerChocobo.level - 5),
        playerChocobo.level + 5
      )
      newChocobo.region = nemesis.homeRegion
      gameStore.chocobos.push(newChocobo)
      nemesis.chocoboIds.push(newChocobo.id)
    }
  }
}